<template>
  <!-- Error boundary catches config validation errors and shows user-friendly message -->
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    >
    </FileConverter>
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

const converterConfig = parseAndValidateConverterConfig('ttc-to-ttf-converter', 'TTC → TTF');

function handleBatchCreated(batchId: string) {
  console.log('[TTC-to-TTF Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[TTC-to-TTF Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[TTC-to-TTF Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[TTC-to-TTF Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[TTC-to-TTF Converter] Credits updated:', credits);
}
</script>
